/*
 * EVRYDAY Desi Pop games (vanilla). Loaded by the dp-quiz / dp-meter / dp-stack / dp-challenge
 * sections only. Each root carries data-dp-game="<name>" and finds the live SKU catalogue in
 * <script type="application/json" data-dp-catalog>. Server HTML is a complete no-JS fallback;
 * this file upgrades it. Uses window.DP (dp.js) for storage, confetti, tweens and multi-add.
 * No discounts or money promises: rewards are badges and celebration only.
 */
(function () {
  'use strict';
  if (window.__dpGames) return;
  window.__dpGames = true;

  var DP = window.DP || {};
  var store = DP.store || { get: function (k, f) { return f; }, set: function () {}, del: function () {} };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function catalog(root) {
    var el = root.querySelector('script[data-dp-catalog]') || document.querySelector('script[data-dp-catalog]');
    try { return JSON.parse(el.textContent).filter(function (p) { return p && p.variantId; }); } catch (e) { return []; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rupees(paise) { return DP.money ? DP.money(paise) : String(Math.round(paise / 100)); }
  function confetti(el, n) {
    if (!DP.confetti || !el) return;
    var r = el.getBoundingClientRect();
    DP.confetti({ x: r.left + r.width / 2, y: r.top + r.height / 3, count: n || 90 });
  }
  function addOne(btn, p) {
    if (!p || !p.available) return;
    btn.classList.add('is-loading'); btn.disabled = true;
    if (DP.fly) DP.fly(btn, p.img);
    var done = function () { btn.classList.remove('is-loading'); btn.disabled = false; };
    (DP.addItems ? DP.addItems([{ id: p.variantId, quantity: 1 }]) : Promise.reject(new Error('cart')))
      .then(done, function () { done(); window.location.href = p.url; });
  }
  function card(p, opts) {
    opts = opts || {};
    return '<article class="dp-mini" style="--flv:' + esc(p.hex) + '">' +
      '<a class="dp-mini__img" href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="" width="180" height="180" loading="lazy"></a>' +
      '<div class="dp-mini__body"><span class="dp-mini__fam">' + esc(p.familyName) + ' · ' + esc(p.size) + '</span>' +
      '<a class="dp-mini__name" href="' + esc(p.url) + '">' + esc(p.flavour) + '</a>' +
      '<span class="dp-mini__price">' + esc(p.priceLabel) + '</span>' +
      (opts.atc === false ? '' : (p.available
        ? '<button type="button" class="dp-btn dp-btn--sm dp-btn--flv" data-dp-add="' + esc(p.handle) + '">Add to cart</button>'
        : '<a class="dp-btn dp-btn--sm is-soldout" href="' + esc(p.url) + '">Sold out · View</a>')) +
      '</div></article>';
  }

  /* ============================== QUIZ ============================== */
  var QUIZ_FAMILY = {
    goal: { muscle: { protein: 2, creatine: 1 }, energy: { preworkout: 3 }, recover: { bcaa: 2, protein: 1 }, strength: { creatine: 3 }, daily: { protein: 3 } },
    time: { morning: { protein: 1 }, before: { preworkout: 2, creatine: 1 }, during: { bcaa: 2 }, after: { protein: 2, creatine: 1 } }
  };
  var TASTE = {
    choco: ['Chocolate'], dessert: ['Malai Kulfi'], citrus: ['Orange', 'Lemon Burst', 'Tangy Orange'],
    berry: ['Blueberry'], plain: ['Unflavoured']
  };
  var TASTE_FALLBACK = { protein: 'Chocolate', preworkout: 'Orange', bcaa: 'Blueberry', creatine: 'Unflavoured' };

  function quiz(root) {
    var items = catalog(root);
    var steps = $$(root, '[data-q-step]');
    var bar = $(root, '[data-q-bar]');
    var count = $(root, '[data-q-count]');
    var result = $(root, '[data-q-result]');
    var answers = {};
    var i = 0;
    root.classList.add('is-live');

    function show(n) {
      i = n;
      steps.forEach(function (s, k) { s.hidden = k !== n; s.classList.toggle('is-current', k === n); });
      result.hidden = n < steps.length;
      var pct = Math.round((Math.min(n, steps.length) / steps.length) * 100);
      if (bar) bar.style.setProperty('--p', pct + '%');
      if (count) count.textContent = n < steps.length ? 'Question ' + (n + 1) + ' of ' + steps.length : 'Your match';
      var focusTarget = n < steps.length ? steps[n].querySelector('legend, h3') : result.querySelector('h3');
      if (focusTarget && root.__started) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus({ preventScroll: true }); }
    }
    function pick() {
      var score = { protein: 0, preworkout: 0, bcaa: 0, creatine: 0 };
      ['goal', 'time'].forEach(function (q) {
        var add = (QUIZ_FAMILY[q] || {})[answers[q]] || {};
        Object.keys(add).forEach(function (f) { score[f] += add[f]; });
      });
      if (answers.taste === 'plain') score.creatine += 1.5;
      if (answers.taste === 'dessert' || answers.taste === 'choco') score.protein += 1;
      if (answers.taste === 'berry') score.bcaa += 1;
      var fam = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0];
      var famItems = items.filter(function (p) { return p.family === fam; });
      var wanted = TASTE[answers.taste] || [];
      var best = famItems.filter(function (p) { return wanted.indexOf(p.flavour) > -1 && p.available; })[0] ||
        famItems.filter(function (p) { return p.flavour === TASTE_FALLBACK[fam] && p.available; })[0] ||
        famItems.filter(function (p) { return p.available; })[0] || famItems[0];
      var partnerFam = { protein: 'creatine', preworkout: 'bcaa', bcaa: 'protein', creatine: 'protein' }[fam];
      var partner = items.filter(function (p) { return p.family === partnerFam && p.available; })[0];
      return { main: best, partner: partner };
    }
    function finish() {
      var r = pick();
      store.set('quiz', { answers: answers, handle: r.main && r.main.handle });
      var slot = $(root, '[data-q-match]');
      var partnerSlot = $(root, '[data-q-partner]');
      if (r.main) {
        slot.innerHTML = card(r.main);
        root.style.setProperty('--flv', r.main.hex);
        var why = $(root, '[data-q-why]');
        if (why) why.textContent = r.main.key ? (r.main.key + ' ' + r.main.keyLabel + '.') : ('Built for ' + r.main.keyLabel + '.');
      }
      if (partnerSlot) partnerSlot.innerHTML = r.partner ? card(r.partner) : '';
      show(steps.length);
      if (!reduce.matches) setTimeout(function () { confetti(result, 70); }, 180);
    }
    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('input[type="radio"]')) return;
      root.__started = true;
      answers[input.name.replace(/^q-/, '').replace(/-.*/, '')] = input.value;
      var next = i + 1;
      setTimeout(function () { if (next >= steps.length) finish(); else show(next); }, reduce.matches ? 0 : 260);
    });
    root.addEventListener('click', function (e) {
      var back = e.target.closest('[data-q-back]');
      if (back) { e.preventDefault(); show(Math.max(0, i - 1)); return; }
      var again = e.target.closest('[data-q-restart]');
      if (again) {
        e.preventDefault(); answers = {};
        $$(root, 'input[type="radio"]').forEach(function (r) { r.checked = false; });
        root.style.removeProperty('--flv'); show(0); return;
      }
      var add = e.target.closest('[data-dp-add]');
      if (add) addOne(add, items.filter(function (p) { return p.handle === add.getAttribute('data-dp-add'); })[0]);
    });
    show(0);
  }

  /* ============================== METER ============================== */
  function meter(root) {
    var items = catalog(root).filter(function (p) { return p.family === 'protein'; });
    var weight = $(root, '[data-m-weight]'), goal = $(root, '[data-m-goal]'), food = $(root, '[data-m-food]');
    var out = {
      weight: $(root, '[data-m-weight-out]'), food: $(root, '[data-m-food-out]'), target: $(root, '[data-m-target]'),
      gap: $(root, '[data-m-gap]'), scoops: $(root, '[data-m-scoops]'), days: $(root, '[data-m-days]'), sentence: $(root, '[data-m-sentence]')
    };
    var fill = $(root, '[data-m-fill]'), scoopIcons = $$(root, '[data-m-scoop]');
    var flavourSel = $(root, '[data-m-flavour]'), addBtn = $(root, '[data-m-add]');
    var PER = parseFloat(root.getAttribute('data-per-scoop')) || 25.5;
    var SERV = parseFloat(root.getAttribute('data-servings')) || 33;
    root.classList.add('is-live');
    var saved = store.get('meter', null);
    if (saved) {
      weight.value = saved.w; food.value = saved.f;
      if (goal.querySelector('option[value="' + saved.g + '"]')) goal.value = saved.g;
    }

    function calc() {
      var w = +weight.value, gk = parseFloat(goal.value), f = +food.value;
      var target = Math.round(w * gk);
      var gap = Math.max(0, target - f);
      var MAX = 2;
      var scoops = Math.min(MAX, Math.round((gap / PER) * 2) / 2);
      var days = scoops > 0 ? Math.floor(SERV / scoops) : 0;
      store.set('meter', { w: w, g: goal.value, f: f });
      out.weight.textContent = w + ' kg';
      out.food.textContent = f + ' g';
      DP.tween ? DP.tween(out.target, target) : (out.target.textContent = target);
      DP.tween ? DP.tween(out.gap, gap) : (out.gap.textContent = gap);
      out.scoops.textContent = scoops % 1 ? scoops.toFixed(1) : String(scoops);
      out.days.textContent = days ? String(days) : '–';
      var pct = target ? Math.min(100, Math.round(((Math.min(gap, scoops * PER) + f) / target) * 100)) : 0;
      if (fill) fill.style.setProperty('--fill-k', String(pct / 100));
      scoopIcons.forEach(function (s, k) { s.classList.toggle('is-on', k < Math.ceil(scoops)); s.classList.toggle('is-half', k === Math.floor(scoops) && scoops % 1 !== 0); });
      if (out.sentence) {
        var capped = gap / PER > MAX;
        out.sentence.textContent = capped
          ? 'The meter stops at ' + MAX + ' scoops (' + (MAX * PER).toFixed(1) + 'g). Close the rest with protein-rich meals. One 1 kg tub lasts about ' + days + ' days at ' + MAX + ' a day.'
          : gap <= 0
          ? 'Your meals already cover this guideline. A scoop is there on the days they do not.'
          : 'About ' + (scoops % 1 ? scoops.toFixed(1) : scoops) + ' scoop' + (scoops === 1 ? '' : 's') + ' a day closes the gap' + (days ? ', so one 1 kg tub lasts about ' + days + ' days.' : '.');
      }
      [weight, food].forEach(function (r) {
        var pc = ((r.value - r.min) / (r.max - r.min)) * 100;
        r.style.setProperty('--pc', pc + '%');
      });
    }
    root.addEventListener('input', calc);
    root.addEventListener('change', calc);
    function label() {
      var p = items.filter(function (x) { return x.handle === flavourSel.value; })[0];
      if (p && addBtn) addBtn.textContent = p.available ? 'Add ' + p.flavour + ' · ' + p.priceLabel : p.flavour + ' is sold out';
      if (p && addBtn) addBtn.disabled = !p.available;
    }
    if (flavourSel) flavourSel.addEventListener('change', label);
    label();
    if (addBtn) addBtn.addEventListener('click', function () {
      var p = items.filter(function (x) { return x.handle === flavourSel.value; })[0] || items[0];
      addOne(addBtn, p);
    });
    calc();
  }

  /* ============================== STACK ============================== */
  var LEVELS = [
    { n: 0, name: 'Pick your first tub', note: 'Tap one flavour from any row.' },
    { n: 1, name: 'Starter', note: 'Nice start. One more family to level up.' },
    { n: 2, name: 'Gym Regular', note: 'Two down. Your routine is taking shape.' },
    { n: 3, name: 'Almost Full Stack', note: 'One row left. Finish the stack.' },
    { n: 4, name: 'Full Stack', note: 'Every row covered. Roz ka protein, sorted.' }
  ];
  function stack(root) {
    var items = catalog(root);
    var ring = $(root, '[data-s-ring]'), level = $(root, '[data-s-level]'), note = $(root, '[data-s-note]');
    var countEl = $(root, '[data-s-count]'), totalEl = $(root, '[data-s-total]'), addAll = $(root, '[data-s-addall]');
    var badges = $$(root, '[data-s-badge]');
    var last = -1;
    root.classList.add('is-live');
    var saved = store.get('stack', {});
    var restored = 0;
    Object.keys(saved).forEach(function (fam) {
      var r = root.querySelector('input[name="s-' + fam + '"][value="' + saved[fam] + '"]');
      if (r && !r.disabled) { r.checked = true; restored++; }
    });
    var resume = $(root, '[data-s-resume]');
    if (resume && restored) resume.hidden = false;

    function state() {
      var picks = {};
      $$(root, 'input[type="radio"]:checked').forEach(function (r) { picks[r.name.slice(2)] = r.value; });
      return picks;
    }
    function render(celebrate) {
      var picks = state();
      store.set('stack', picks);
      var n = Object.keys(picks).length;
      var chosen = Object.keys(picks).map(function (f) { return items.filter(function (p) { return p.handle === picks[f]; })[0]; }).filter(Boolean);
      var total = chosen.reduce(function (s, p) { return s + (p.available ? p.price : 0); }, 0);
      if (ring) ring.style.setProperty('--p-n', String((n / 4) * 100));
      if (countEl) countEl.textContent = n + '/4';
      if (level) level.textContent = LEVELS[n].name;
      if (note) note.textContent = LEVELS[n].note;
      if (totalEl) totalEl.textContent = rupees(total);
      badges.forEach(function (b, k) {
        var on = n >= k + 1;
        if (on && !b.classList.contains('is-on') && celebrate && !reduce.matches) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
        b.classList.toggle('is-on', on);
      });
      if (addAll) {
        var nAdd = chosen.filter(function (p) { return p.available; }).length;
        addAll.disabled = !nAdd;
        var lbl = addAll.querySelector('[data-s-addlabel]');
        if (lbl) lbl.textContent = nAdd ? 'Add ' + nAdd + (nAdd === 1 ? ' tub' : ' tubs') + ' to cart' : 'Add stack to cart';
      }
      if (celebrate && n === 4 && last !== 4) confetti(ring || root, 140);
      last = n;
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]')) render(true); });
    root.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-s-clear]');
      if (clr) { $$(root, 'input[type="radio"]').forEach(function (r) { r.checked = false; }); if (resume) resume.hidden = true; render(false); return; }
      if (e.target.closest('[data-s-addall]')) {
        var picks = state();
        var list = Object.keys(picks).map(function (f) { return items.filter(function (p) { return p.handle === picks[f] && p.available; })[0]; }).filter(Boolean);
        if (!list.length) return;
        addAll.classList.add('is-loading'); addAll.disabled = true;
        if (DP.fly) DP.fly(addAll, list[0].img);
        DP.addItems(list.map(function (p) { return { id: p.variantId, quantity: 1 }; }))
          .catch(function () { window.location.href = '/cart'; })
          .then(function () { addAll.classList.remove('is-loading'); addAll.disabled = false; });
      }
    });
    render(false);
  }

  /* ============================ CHALLENGE ============================ */
  /* Honest tracker: days are ticked in order (day 1, then 2, ...), only the next day can be ticked
     and only the latest day can be unticked. The streak is the run of ticked days from day 1. */
  var MILESTONES = { 7: 'One week strong', 14: 'Two weeks in', 21: 'Habit unlocked', 30: 'Roz Challenge complete' };
  function challenge(root) {
    var days = $$(root, '[data-c-day]');
    var streakEl = $(root, '[data-c-streak]'), totalEl = $(root, '[data-c-total]'), msg = $(root, '[data-c-msg]');
    var live = $(root, '[data-c-live]');
    var resumeNote = $(root, '[data-c-resume]');
    root.classList.add('is-live');
    /* Older saves could hold any set of days; keep only the unbroken run from day 1. */
    var saved = store.get('challenge', []);
    var count = 0;
    while (saved.indexOf(count + 1) > -1 && count < days.length) count++;
    function save() { var a = []; for (var d = 1; d <= count; d++) a.push(d); store.set('challenge', a); }
    save();
    if (resumeNote && count > 0) resumeNote.hidden = false;
    function paint(changed) {
      days.forEach(function (b) {
        var d = +b.getAttribute('data-c-day');
        var on = d <= count;
        var actionable = d === count + 1 || d === count;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-disabled', actionable ? 'false' : 'true');
        b.classList.toggle('is-on', on);
        b.classList.toggle('is-next', d === count + 1);
        b.classList.toggle('is-locked', !actionable);
        if (changed === d && on && !reduce.matches) { b.classList.remove('is-stamp'); void b.offsetWidth; b.classList.add('is-stamp'); }
      });
      if (streakEl) streakEl.textContent = count;
      if (totalEl) totalEl.textContent = count;
      var best = 0;
      Object.keys(MILESTONES).forEach(function (m) { if (count >= +m) best = +m; });
      if (msg) msg.textContent = count >= days.length ? MILESTONES[30] + '!' : best ? MILESTONES[best] + '! Next up: day ' + (count + 1) + '.' : (count ? 'Keep going. Next up: day ' + (count + 1) + '.' : 'Had your scoop today? Tick day 1.');
      $$(root, '[data-c-mile]').forEach(function (m) { m.classList.toggle('is-on', count >= +m.getAttribute('data-c-mile')); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-c-day]');
      if (b) {
        var d = +b.getAttribute('data-c-day');
        if (d === count + 1) {
          count = d; save(); paint(d);
          if (MILESTONES[count]) {
            confetti(b, count === 30 ? 160 : 70);
            if (live) live.textContent = MILESTONES[count] + '. ' + count + ' day streak.';
          } else if (live) live.textContent = 'Day ' + d + ' ticked. ' + count + ' day streak.';
        } else if (d === count) {
          count = d - 1; save(); paint(0);
          if (live) live.textContent = 'Day ' + d + ' unticked. ' + count + ' day streak.';
        } else if (live) {
          live.textContent = d > count ? 'Tick day ' + (count + 1) + ' first. Days go in order.' : 'Only the latest day can be unticked.';
        }
        return;
      }
      if (e.target.closest('[data-c-reset]')) { count = 0; save(); paint(0); if (resumeNote) resumeNote.hidden = true; if (live) live.textContent = 'Challenge reset.'; }
    });
    paint(0);
  }

  var GAMES = { quiz: quiz, meter: meter, stack: stack, challenge: challenge };
  function boot(scope) {
    $$(scope || document, '[data-dp-game]').forEach(function (root) {
      if (root.__dpGame) return;
      var fn = GAMES[root.getAttribute('data-dp-game')];
      if (!fn) return;
      root.__dpGame = true;
      try { fn(root); } catch (err) { root.classList.remove('is-live'); if (window.console) console.warn('[dp-games]', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
